import moment from 'moment';

export default function generateObjectToutProductFromRender(parent = {}) {
    const { model } = parent;
    let adultsText = '';
    let kidsText = '';

    const tour = model.get('tour');
    const id = model.get('id');
    const nights = tour.get('nights');
    const nightsInHotel = tour.get('nightsInHotel');
    const differentNightsInHotelClass = nights !== nightsInHotel ? 'hotelTour__nights-in-hotel_warning' : '';
    const adults = tour.get('touristGroup')?.adults ?? null;
    const kids = tour.get('touristGroup')?.kids ?? null;
    const infants = tour.get('touristGroup')?.infants ?? null;
    const roomName = tour.get('room')?.name;
    const mealName = tour.get('meal')?.get('name');
    const flightType = tour.get('flightType') ?? null;
    const checkInDateRangeFrom = tour.get('checkInDateRange').get('from');
    const checkInDateRangeTo = tour.get('checkInDateRange').get('to');
    const datetimeForward = `${moment(checkInDateRangeFrom).format('DD MMMM')}, ${moment(checkInDateRangeFrom).format('ddd')}`;
    const datetimeBackward = `${moment(checkInDateRangeTo).format('DD MMMM')}, ${moment(checkInDateRangeTo).format('ddd')}`;

    if (adults > 0) {
        adultsText = `${adults} взросл${adults.wordEnding('ый;ых;ых')}`;
        if (kids > 0) {
            kidsText = ` и ${kids + infants} ${(kids + infants).wordEnding('ребенок;детей;детей')}`;
        } else if (infants > 0) {
            kidsText = ` и ${infants} ${infants.wordEnding('младенец;младенца;младенцев')}`;
        }
    }

    return {
        id,
        tour,
        nights,
        nightsInHotel,
        differentNightsInHotelClass,
        roomName,
        mealName,
        flightType,
        adultsText,
        kidsText,
        checkInDateRangeFrom,
        datetimeForward,
        datetimeBackward,
    };
}